import { render } from "./ProjectProcureAttachmentForm.vue?vue&type=template&id=43b3df42&scoped=true&ts=true"
import script from "./ProjectProcureAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureAttachmentForm.ts?vue&type=script&lang=ts"

import "./ProjectProcureAttachmentForm.scss?vue&type=style&index=0&id=43b3df42&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b3df42"]])

export default __exports__